/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 */

	'use strict';
	/*globals Tc */

	/**
	 * FileUpload module implementation copied from forms/ui
	 *
	 * @author Renaldas Szentiks
	 * @namespace Tc.Module
	 * @class FileUpload
	 * @extends Tc.Module
	 */
	Tc.Module.FileUpload = Tc.Module.extend({
		/**
		 * Initializes the module.
		 *
		 * @method init
		 * @constructor
		 * @param {jQuery} $ctx the jquery context
		 * @param {Sandbox} sandbox the sandbox to get the resources from
		 * @param {String} modId the unique module id
		 */
		init: function ($ctx, sandbox, modId) {
			this._super($ctx, sandbox, modId);
			this.fileList = $('.fileList', this.$ctx);
			this.name = this.getUploadField().data('name');
			this.url = this.$ctx.data('url');
			this.SizeCalculator.init(this.$ctx.data('size-limit'), this.$ctx.data('file-size-limit'));
			this.generateLinks = this.$ctx.data('generate-links') === true || this.$ctx.data('generate-links') === 'true';
			this.actionProvider = this.$ctx.data('action-provider');
		},

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			this.sandbox.subscribe('randomFormToken', this);
			this.getUploadField().on('change', $.proxy(this.changeHandler, this));
			this.getUploadField().on('prefill', $.proxy(this.prefillHandler, this));
			this.getUploadField().on('resetFiles', $.proxy(this.removeAllFilesHandler, this));
			this.populateUploadedFiles();
			callback();
		},

		after: function () {
			this.generateRandomFormToken();
		},

		populateUploadedFiles: function() {

			var mod = this,
				$ctx = mod.$ctx;

			var json = $ctx.data('uploaded-attachment-info-json');
			if (json.length > 0) {
				for (var i in json) {
					var data = json[i];
					mod.appendFileEntry(data);
				}
			}
		},

		generateRandomFormToken: function () {
			if (this.$ctx.data('random-token')) {
				this.randomFormToken = this.$ctx.data('random-token');
			}
			else {
				this.randomFormToken = Math.round(Math.random() * 100000) + '' + new Date().getTime();
			}
			var formTokenFieldGen = $('<input>').attr('type', 'hidden').attr('name', 'randomToken').val(this.randomFormToken);
			this.$ctx.closest('form').attr('novalidate', true).append(formTokenFieldGen);
		},

		getName: function () {
			return this.name;
		},

		getUrl: function () {
			return this.url;
		},

		getUploadField: function () {
			return $('input[type="file"]', this.$ctx);
		},

		showDialog: function (title, text) {
			$('<div/>').attr('title', title).append(text).dialog();
		},

		changeHandler: function (event) {
			if (event) {
				event.preventDefault();
			}
			if (this.getUploadField().val()) {
				this.uploadFile(this.getUploadField());
			}
		},

		prefillHandler: function (event, data) {
			if (data) {
				if (data.items instanceof Array) { // array of attachments
					for (var i = 0; i < data.items.length; i++) {
						this.appendFileEntry(data.items[i]);
					}
				} else { // single attachment
					this.appendFileEntry(data);
				}
			}
		},

		uploadResponseHandler: function (response) {
			if (response.success === true || response.success === 'true') {
				this.appendFileEntry(response.item);
			} else {
				if (response.errorMessage) { // unknown error
					this.showDialog('Error', response.errorMessage);
				} else if (response.errorCode === '1' || response.errorCode === 1) { // file size too big
					this.showDialog('Error', this.$ctx.data('error-file-size-limit').replace('{0}', this.formatSize(this.SizeCalculator.getFileSizeLimit())));
				}
			}
		},

		appendFileEntry: function (data) {
			/* Creates the following markup:
				<div>
				<a class="fileDescription" href="..." target="_blank"> or <span class="fileDescription">
				<span class="text">{file name}</span>
				<span class="size">({size})</span>
				</a> or </span>
				<span class="remove-icon"></span>
				<input type="hidden" data-type="file" name="{input field name}" value="{file id}"/>
				</div>
				*/
			if (data && typeof data.uuid !== 'undefined') {
				var sizeStatus = this.SizeCalculator.add(data.size);
				if (sizeStatus.ok && sizeStatus.fileOk) {
					var name = data.fileName ? data.fileName : data.uuid,
						listEntry = $('<div/>'),
						fileLink = $('<a>').addClass('fileDescription').attr('href', this.getUrl() + '?uuid=' + data.uuid).attr('target', '_blank'),
						linkText = $('<span>').attr('class', 'text').text(name),
						sizeValue = $('<span>').attr('class', 'size').text('(' + this.formatSize(data.size) + ')'),
						removeIcon = $('<span>').attr('class', 'remove-icon'),
						hiddenField = $('<input>').attr('type', 'hidden').attr('name', this.getName());
					if (!this.generateLinks) {
						fileLink = $('<span>').addClass('fileDescription');
					}

					removeIcon.on('click', { uuid: data.uuid, entry: listEntry }, $.proxy(this.removeFileHandler, this));
					hiddenField.val(data.uuid);
					hiddenField.data('type', 'file'); // required to mark this field for the summary

					this.fileList.append(listEntry.append(fileLink.append(linkText).append(sizeValue)).append(removeIcon).append(hiddenField));
				} else {
					this.SizeCalculator.remove(data.size);
					if (!sizeStatus.ok) {
						this.showDialog('Error', this.$ctx.data('error-size-limit').replace('{0}', this.formatSize(this.SizeCalculator.getSizeLimit())));
					} else {
						this.showDialog('Error', this.$ctx.data('error-file-size-limit').replace('{0}', this.formatSize(this.SizeCalculator.getFileSizeLimit())));
					}
				}
			}
		},

		formatSize: function (size) {
			if (size) {
				size = parseInt(size);
				if (!isNaN(size) && size > 1024) {
					var suffix = 'kB';
					size = size / 1024;
					if (size >= 1024) {
						size = size / 1024;
						suffix = 'mB';
					}
					size = Math.round(size * 10) / 10;
					return size + suffix;
				} else {
					return '1kB';
				}
			}
			return '0kB';
		},

		removeAllFilesHandler: function() {
			this.fileList.empty();
		},

		removeFileHandler: function (event) {
			if (event) {
				event.preventDefault();
			}
			var $this = this,
				uuid = event.data.uuid,
				listEntry = event.data.entry;

			listEntry.remove();

			// response does not matter, since the hidden parameter is already
			// removed ant the attachment won't be connected to the form anymore
			$.ajax({
				type: 'POST',
				url: $this.getUrl(),
				cache: false,
				data: {
					uuid: uuid,
					randomToken: $this.randomFormToken
				}
			});
		},

		getFrameName: function () {
			return 'UploadFrame' + this.getName();
		},

		uploadFile: function (field) {
			this.prepareField(field);

			// create iframe:
			if (this.frame) {
				this.frame.remove();
				this.frame = null;
			}
			this.frame = $('<iframe id="' + this.getFrameName() + '" name="' + this.getFrameName() + '" style="display: none">');
			$('body').append(this.frame);
			this.frame.on('load', $.proxy(this.loadHandler, this));

			var inputFieldName = $('<input>').attr('type', 'hidden').attr('name', 'fieldName').val(this.getName()),
				formTokenField = $('<input>').attr('type', 'hidden').attr('name', 'randomToken').val(this.randomFormToken),
				actionProviderField = $('<input>').attr('type', 'hidden').attr('name', 'actionProvider').val(this.actionProvider),
				charsetField = $('<input>').attr('type', 'hidden').attr('name', '_charset_').val('UTF-8'),
				formPathField = $('<input>').attr('type', 'hidden').attr('name', 'formPath').val(this.getFormParameter(':formstart'));

			// create form:
			if (this.form) {
				this.form.remove();
				this.form = null;
			}
			this.form = $('<form method="post" action="' + this.getUrl() + '" enctype="multipart/form-data" target="' + this.getFrameName() + '" style="display: none">');
			this.form.append(field);
			if (!this.form.html()) { // for IE8 and lower
				this.form = $('<form>').attr('method', 'post').attr('action', this.getUrl()).attr('enctype', 'multipart/form-data').attr('target', this.getFrameName()).attr('style', 'display: none');
				this.form.append(field);
			}
			this.form.append(inputFieldName).append(formTokenField).append(actionProviderField).append(formPathField).append(charsetField);

			$('body').append(this.form);

			this.form.submit();
		},

		getFormParameter: function(parameterName) {
			if (!this.currentForm) {
				this.currentForm = this.$ctx.parents('form');
			}
			return $('input[name="' + parameterName + '"]', this.currentForm).val();
		},

		prepareField: function (field) {
			this.originalFieldName = field.attr('name');
			if (!this.originalFieldPlaceholder) {
				this.originalFieldPlaceholder = $('<span style="display: none"/>');
				this.originalFieldPlaceholder.insertBefore(field);
			}
			this.originalField = field.attr('name', 'file').detach();
			this.showLoadingIndicator();
		},

		resetField: function () {
			this.originalField.attr('name', this.originalFieldName);
			this.showLoadingIndicator(false);
			this.originalField.clone(true).insertAfter(this.originalFieldPlaceholder);
		},

		showLoadingIndicator: function (show) {
			if (!this.loadingIndicator) {
				this.loadingIndicator = $('.js-loading-indicator', this.$ctx);
			}
			if (show === false) {
				this.loadingIndicator.hide();
			} else {
				this.loadingIndicator.show();
			}

		},

		loadHandler: function () {
			this.resetField();
			var content = this.frame.contents().find('#content');
			if (content.length > 0) {
				this.uploadResponseHandler(content.data('response'));
			}
		},

		/**
		 * Singleton for size limit for attachments in the whole form/page
		 */
		SizeCalculator: {
			init: function (limit, fileLimit) {
				if (!this.initialized) {
					this.initialized = true;
					this.sizeLimit = limit;
					if (!this.sizeLimit) {
						this.sizeLimit = -1;
					}
					this.fileSizeLimit = fileLimit;
					if (!this.fileSizeLimit) {
						this.fileSizeLimit = -1;
					}
					this.size = 0;
				}
			},

			getSizeLimit: function () {
				return this.sizeLimit;
			},

			getFileSizeLimit: function () {
				return this.fileSizeLimit;
			},

			add: function (size) {
				this.size += size;
				if (this.fileSizeLimit >= 0 && this.fileSizeLimit < size) {
					return this.getStatus(false, size - this.fileSizeLimit);
				}
				return this.getStatus();
			},

			remove: function (size) {
				this.size -= size;
				return this.getStatus();
			},

			getStatus: function (fileSizeStatusOk, fileOverhead) {
				var overhead = this.size - this.sizeLimit;
				fileOverhead = typeof fileOverhead === 'undefined' ? 0 : fileOverhead;
				fileSizeStatusOk = fileSizeStatusOk !== false ? true : false;
				if (this.sizeLimit >= 0 && overhead > 0) {
					return {
						ok: false,
						fileOk: fileSizeStatusOk,
						overhead: overhead,
						fileOverhead: fileOverhead
					};
				}
				return {
					ok: true,
					fileOk: fileSizeStatusOk,
					overhead: 0,
					fileOverhead: fileOverhead
				};
			}
		}
	});
}(Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/modules/Tc.Module.FileUpload.js
// module id = 43
// module chunks = 0